import axios from 'axios';
import { BUSINESSES_URL } from 'api/constants';
import {
  createErrorFromAxiosMultipleErrors,
  createErrorFromAxiosUserMessageError,
} from 'api/utilities';

export async function getBusinessesList({ page, size }, filters) {
  const params = {
    page,
    size,
    kyb_status: filters.kybStatus,
    npwp_status: filters.npwpStatus,
    q: filters.searchKeyword,
    is_kyb_registration_completed: filters.isKybRegistrationCompleted,
    search_by: filters.searchBy,
  };
  if (filters.startCreatedDate) {
    params.start_created_date = filters.startCreatedDate;
  }
  if (filters.endCreatedDate) {
    params.end_created_date = filters.endCreatedDate;
  }

  try {
    return await axios.get(BUSINESSES_URL, { params });
  } catch (e) {
    throw createErrorFromAxiosUserMessageError(e);
  }
}

export async function getBusinessDetails(businessId) {
  const url = `${BUSINESSES_URL}/${businessId}`;
  try {
    return await axios.get(url);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getBusinessIdentities(businessId) {
  const url = `${BUSINESSES_URL}/${businessId}/identities`;
  try {
    return await axios.get(url);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getDefaultBusinessBankAccount(businessId) {
  const url = `${BUSINESSES_URL}/${businessId}/bank-accounts`;
  try {
    return await axios.get(url, {
      validateStatus: status =>
        (status >= 200 && status < 300) || status === 404,
    });
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function updateKybStatus(businessId, status, reason = '') {
  const url = `${BUSINESSES_URL}/${businessId}/kyb/status`;
  const data = {
    kyb_status: status,
    reason,
  };
  try {
    return await axios.patch(url, data);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getKybLogs(businessId) {
  const url = `${BUSINESSES_URL}/${businessId}/kyb/logs`;
  const params = {
    page: 1,
    size: 2,
  };
  try {
    return await axios.get(url, { params });
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function updateBankAccount(businessId, data) {
  const url = `${BUSINESSES_URL}/${businessId}/bank-accounts`;
  try {
    return await axios.patch(url, data);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function updateKtpDetails(businessId, data) {
  const url = `${BUSINESSES_URL}/${businessId}/ktp`;
  try {
    return await axios.patch(url, data);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getNpwpLogs(businessId) {
  const url = `${BUSINESSES_URL}/${businessId}/npwp/logs`;
  const params = {
    page: 1,
    size: 2,
  };
  try {
    return await axios.get(url, { params });
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function updateNpwpStatus(businessId, status, reason = '') {
  const url = `${BUSINESSES_URL}/${businessId}/npwp/status`;
  const data = {
    status,
    reason,
  };
  try {
    return await axios.patch(url, data);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function updateNpwpDetails(businessId, data) {
  const url = `${BUSINESSES_URL}/${businessId}/npwp`;
  try {
    return await axios.patch(url, data);
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}
